<template>
  <v-row justify="center" dense>
    <v-col cols="12" lg="10" md="10" v-if="dataSource.series[0].data.length">
      <MixedCarts :dataSource="dataSource" />
    </v-col>
    <v-col cols="auto" v-else> Nothing saved for this given period </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../../../charts/ApexCartsMixed.vue";
export default {
  name: "OnboardingReco",
  components: {
    MixedCarts,
  },
  data() {
    return {
      elements: [
        "gender_noel",
        "budget_female",
        "budget_male",
        "interest_female",
        "interest_male",
        "intent",
        "made_eco",
        "first_reco_noel",
        "second_reco_noel",
        "third_reco_noel",
        "suggestion_noel",
        "ENDLESS_RECO_NOEL",
      ],
      dataSource: {
        type: "bar",
        height: 350,
        series: [
          {
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "85%",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",
          },
        },
      },
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  mounted() {
    this.set_data();
  },
  methods: {
    set_data() {
      for (let i = 0; i < this.elements.length; i++) {
        const element = this.elements[i];
        const res = Object.entries(this.onboarding).find((data) => {
          if (data[0] === element) return data;
        });
        if (res) {
          const key = res[0];
          const value = res[1];
          this.dataSource.series[0].data.push({
            x: this.store_config.i18n[this.$i18n.locale].buttons[key]
              ? this.store_config.i18n[this.$i18n.locale].buttons[key].split(
                  "&"
                )[0]
              : this.store_config.i18n[this.$i18n.locale].buttons[key] || key,
            y: value,
          });
        }
        //  else {
        //   console.log(element, "null");
        // }
      }
    },
  },
};
</script>
